import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { formatMoney } from "../config/store";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <div className="container">
        <header className="shop-header">
          <h1>Shop All</h1>
          <p>Browse our curated collection of unique gifts and essentials.</p>
        </header>

        <div className="product-grid">
          {productData.map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              key={product.id}
              className="product-card"
              onClick={toTop}
            >
              <div className="product-image">
                <img src={product.image} alt={product.name} />
                <div className="image-overlay">
                  <span>View Details</span>
                </div>
              </div>
              <div className="product-info">
                <span className="product-category">{product.category}</span>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">{formatMoney(product.price)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Shop;
